/** Routing that works from the URL hash when allowed, and from memory inside sandboxed viewers that block it. */
let ROUTE: string | null = null;
let renderImpl: () => void = () => {};

export const setRenderer = (fn: () => void) => { renderImpl = fn; };
export const render = () => renderImpl();
export const routeStr = () => (ROUTE ?? location.hash ?? '').replace(/^#\/?/, '');
export const setRoute = (h: string | null) => { ROUTE = h; };
export function navigate(h: string) {
  ROUTE = h;
  try { if (location.hash !== h) history.pushState(null, '', h); } catch {}
  document.getElementById('drawer')?.classList.remove('open');
  render(); window.scrollTo(0, 0);
}
export const go = (h: string) => navigate(h);
